// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Riu-","type":"styles_type__1klRn","choices":"styles_choices__3lyw1"};